import { usePortalSettings } from '@servicetitan/cp-ui';
import { BodyText, Headline, Icon, Stack } from '@servicetitan/design-system';
import { FC } from 'react';
import { AuthLayout } from '../../auth/components/layout/auth.layout';
import * as Styles from './expired-link-page.module.less';

export type ExpiredLinkType = 'invoice' | 'proposal';

/*
 * Must match the ExpiredUrl values LinkV1Controller redirects to when a loginless link is past
 * its expiration date.
 */
export const ExpiredLinkUrls: Record<ExpiredLinkType, string> = {
    invoice: '/invoices/expired-link',
    proposal: '/proposals/expired-link',
};

const ExpiredLinkContent: Record<ExpiredLinkType, { title: string; request: string }> = {
    invoice: {
        title: 'This payment link has expired',
        request: 'a new payment link',
    },
    proposal: {
        title: 'This estimate link has expired',
        request: 'a new link to your estimate',
    },
};

export const ExpiredLinkPage: FC<{ type: ExpiredLinkType }> = ({ type }) => {
    const settings = usePortalSettings();
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- title is '' when tenant settings are unavailable, which ?? would not fall back from
    const companyName = settings?.title ? settings.title : 'the business';
    const { request, title } = ExpiredLinkContent[type];

    return (
        <AuthLayout showSignInBanner={false}>
            <div data-cy="expired-link-page" data-expired-link-type={type}>
                <Stack direction="column" alignItems="center" spacing={2} className="ta-center">
                    <div className={Styles.headerIcon}>
                        <Icon name="timer" className="c-blue-500" size={24} />
                    </div>
                    <Headline size="medium">{title}</Headline>
                    <BodyText subdued>
                        For your security, links are only valid for a limited time. Please contact{' '}
                        {companyName} to request {request}.
                    </BodyText>
                </Stack>
            </div>
        </AuthLayout>
    );
};
